(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jb-buckfast-nucs"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('jb-nuc-features')){
  customElements.define('jb-nuc-features',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.points=Array.from(this.querySelectorAll('[data-feature]'));
      this.slides=Array.from(this.querySelectorAll('[data-feature-image]'));
      this.onSelect=(event)=>{
        const point=event.target.closest('[data-feature]');
        if(point&&this.contains(point))this.select(point.dataset.feature,event.type==='click'&&window.matchMedia('(max-width:749px)').matches);
      };
      this.onBlockSelect=(event)=>{if(event.detail&&event.detail.blockId)this.select(event.detail.blockId);};
      ['focusin','click'].forEach(type=>this.addEventListener(type,this.onSelect));
      this.addEventListener('shopify:block:select',this.onBlockSelect);
      if(this.points[0])this.select(this.points[0].dataset.feature);
    }
    select(key,showImage=false){
      const slide=this.slides.find(item=>item.dataset.featureImage===key);
      if(!slide)return;
      const scrollToImage=()=>{if(showImage)requestAnimationFrame(()=>this.querySelector('.jbn-feature-media').scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));};
      if(this.selected===key&&!slide.hidden){scrollToImage();return;}
      this.selected=key;
      this.points.forEach(point=>{
        const active=point.dataset.feature===key;
        point.classList.toggle('is-active',active);
        point.querySelector('button').setAttribute('aria-pressed',String(active));
      });
      const reveal=()=>{if(this.ready&&this.selected===key){this.slides.forEach(item=>item.hidden=item!==slide);scrollToImage();}};
      const image=slide.querySelector('img');
      if(image&&(!image.complete||!image.naturalWidth)){
        image.loading='eager';
        image.decode().then(reveal).catch(reveal);
      }else reveal();
    }
    disconnectedCallback(){
      ['focusin','click'].forEach(type=>this.removeEventListener(type,this.onSelect));
      this.removeEventListener('shopify:block:select',this.onBlockSelect);
      this.selected=null;
      this.ready=false;
    }
  });
}
if(!customElements.get('jb-nuc-chooser')){
  customElements.define('jb-nuc-chooser',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.buttons=Array.from(this.querySelectorAll('[data-format]'));
      this.panels=Array.from(this.querySelectorAll('[data-panel]'));
      this.querySelector('.jbn-formats').hidden=false;
      this.selected='national';
      this.onClick=(event)=>{const button=event.target.closest('[data-format]');if(button)this.select(button.dataset.format);};
      this.onHash=()=>{
        const season=window.location.hash.slice(1);
        if(['overwintered','spring','summer'].includes(season)){
          this.select(this.selected);
          requestAnimationFrame(()=>this.querySelector('[data-panel="'+this.selected+'"] [data-season="'+season+'"]').scrollIntoView({block:'start'}));
        }
      };
      this.addEventListener('click',this.onClick);
      window.addEventListener('hashchange',this.onHash);
      this.select('national');
      this.onHash();
    }
    select(format){
      this.selected=format;
      this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.format===format)));
      this.panels.forEach(panel=>{panel.hidden=panel.dataset.panel!==format;panel.querySelectorAll('[data-season]').forEach(card=>{if(panel.dataset.panel===format)card.id=card.dataset.season;else card.removeAttribute('id');});});
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);window.removeEventListener('hashchange',this.onHash);this.ready=false;}
  });
}
if(!customElements.get('jb-nuc-video')){
  customElements.define('jb-nuc-video',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.onClick=(event)=>{if(!event.target.closest('a'))return;event.preventDefault();const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/wHoe2ykXm80?autoplay=1';frame.title=this.dataset.title;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';frame.setAttribute('tabindex','0');this.replaceChildren(frame);frame.focus();};
      this.addEventListener('click',this.onClick);
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);this.ready=false;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-flow-nucs-data"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('jb-nuc-features')){
  customElements.define('jb-nuc-features',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.points=Array.from(this.querySelectorAll('[data-feature]'));
      this.slides=Array.from(this.querySelectorAll('[data-feature-image]'));
      this.onSelect=(event)=>{
        const point=event.target.closest('[data-feature]');
        if(point&&this.contains(point))this.select(point.dataset.feature,event.type==='click'&&window.matchMedia('(max-width:749px)').matches);
      };
      this.onBlockSelect=(event)=>{if(event.detail&&event.detail.blockId)this.select(event.detail.blockId);};
      ['focusin','click'].forEach(type=>this.addEventListener(type,this.onSelect));
      this.addEventListener('shopify:block:select',this.onBlockSelect);
      if(this.points[0])this.select(this.points[0].dataset.feature);
    }
    select(key,showImage=false){
      const slide=this.slides.find(item=>item.dataset.featureImage===key);
      if(!slide)return;
      const scrollToImage=()=>{if(showImage)requestAnimationFrame(()=>this.querySelector('.jbn-feature-media').scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));};
      if(this.selected===key&&!slide.hidden){scrollToImage();return;}
      this.selected=key;
      this.points.forEach(point=>{
        const active=point.dataset.feature===key;
        point.classList.toggle('is-active',active);
        point.querySelector('button').setAttribute('aria-pressed',String(active));
      });
      const reveal=()=>{if(this.ready&&this.selected===key){this.slides.forEach(item=>item.hidden=item!==slide);scrollToImage();}};
      const image=slide.querySelector('img');
      if(image&&(!image.complete||!image.naturalWidth)){
        image.loading='eager';
        image.decode().then(reveal).catch(reveal);
      }else reveal();
    }
    disconnectedCallback(){
      ['focusin','click'].forEach(type=>this.removeEventListener(type,this.onSelect));
      this.removeEventListener('shopify:block:select',this.onBlockSelect);
      this.selected=null;
      this.ready=false;
    }
  });
}
if(!customElements.get('jb-nuc-chooser')){
  customElements.define('jb-nuc-chooser',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.buttons=Array.from(this.querySelectorAll('[data-format]'));
      this.panels=Array.from(this.querySelectorAll('[data-panel]'));
      this.querySelector('.jbn-formats').hidden=false;
      this.selected='national';
      this.onClick=(event)=>{const button=event.target.closest('[data-format]');if(button)this.select(button.dataset.format);};
      this.onHash=()=>{
        const season=window.location.hash.slice(1);
        if(['overwintered','spring','summer'].includes(season)){
          this.select(this.selected);
          requestAnimationFrame(()=>this.querySelector('[data-panel="'+this.selected+'"] [data-season="'+season+'"]').scrollIntoView({block:'start'}));
        }
      };
      this.addEventListener('click',this.onClick);
      window.addEventListener('hashchange',this.onHash);
      this.select('national');
      this.onHash();
    }
    select(format){
      this.selected=format;
      this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.format===format)));
      this.panels.forEach(panel=>{panel.hidden=panel.dataset.panel!==format;panel.querySelectorAll('[data-season]').forEach(card=>{if(panel.dataset.panel===format)card.id=card.dataset.season;else card.removeAttribute('id');});});
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);window.removeEventListener('hashchange',this.onHash);this.ready=false;}
  });
}
if(!customElements.get('jb-nuc-video')){
  customElements.define('jb-nuc-video',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.onClick=(event)=>{if(!event.target.closest('a'))return;event.preventDefault();const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/wHoe2ykXm80?autoplay=1';frame.title=this.dataset.title;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';frame.setAttribute('tabindex','0');this.replaceChildren(frame);frame.focus();};
      this.addEventListener('click',this.onClick);
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);this.ready=false;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-nucs-draft"] && !Shopify.designMode) return;
  try {
    

if(!customElements.get('jb-nuc-features')){
  customElements.define('jb-nuc-features',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.points=Array.from(this.querySelectorAll('[data-feature]'));
      this.slides=Array.from(this.querySelectorAll('[data-feature-image]'));
      this.onSelect=(event)=>{
        const point=event.target.closest('[data-feature]');
        if(point&&this.contains(point))this.select(point.dataset.feature,event.type==='click'&&window.matchMedia('(max-width:749px)').matches);
      };
      this.onBlockSelect=(event)=>{if(event.detail&&event.detail.blockId)this.select(event.detail.blockId);};
      ['focusin','click'].forEach(type=>this.addEventListener(type,this.onSelect));
      this.addEventListener('shopify:block:select',this.onBlockSelect);
      if(this.points[0])this.select(this.points[0].dataset.feature);
    }
    select(key,showImage=false){
      const slide=this.slides.find(item=>item.dataset.featureImage===key);
      if(!slide)return;
      const scrollToImage=()=>{if(showImage)requestAnimationFrame(()=>this.querySelector('.jbn-feature-media').scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches?'auto':'smooth'}));};
      if(this.selected===key&&!slide.hidden){scrollToImage();return;}
      this.selected=key;
      this.points.forEach(point=>{
        const active=point.dataset.feature===key;
        point.classList.toggle('is-active',active);
        point.querySelector('button').setAttribute('aria-pressed',String(active));
      });
      const reveal=()=>{if(this.ready&&this.selected===key){this.slides.forEach(item=>item.hidden=item!==slide);scrollToImage();}};
      const image=slide.querySelector('img');
      if(image&&(!image.complete||!image.naturalWidth)){
        image.loading='eager';
        image.decode().then(reveal).catch(reveal);
      }else reveal();
    }
    disconnectedCallback(){
      ['focusin','click'].forEach(type=>this.removeEventListener(type,this.onSelect));
      this.removeEventListener('shopify:block:select',this.onBlockSelect);
      this.selected=null;
      this.ready=false;
    }
  });
}
if(!customElements.get('jb-nuc-chooser')){
  customElements.define('jb-nuc-chooser',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.buttons=Array.from(this.querySelectorAll('[data-format]'));
      this.panels=Array.from(this.querySelectorAll('[data-panel]'));
      this.querySelector('.jbn-formats').hidden=false;
      this.selected='national';
      this.onClick=(event)=>{const button=event.target.closest('[data-format]');if(button)this.select(button.dataset.format);};
      this.onHash=()=>{
        const season=window.location.hash.slice(1);
        if(['overwintered','spring','summer'].includes(season)){
          this.select(this.selected);
          requestAnimationFrame(()=>this.querySelector('[data-panel="'+this.selected+'"] [data-season="'+season+'"]').scrollIntoView({block:'start'}));
        }
      };
      this.addEventListener('click',this.onClick);
      window.addEventListener('hashchange',this.onHash);
      this.select('national');
      this.onHash();
    }
    select(format){
      this.selected=format;
      this.buttons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.format===format)));
      this.panels.forEach(panel=>{panel.hidden=panel.dataset.panel!==format;panel.querySelectorAll('[data-season]').forEach(card=>{if(panel.dataset.panel===format)card.id=card.dataset.season;else card.removeAttribute('id');});});
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);window.removeEventListener('hashchange',this.onHash);this.ready=false;}
  });
}
if(!customElements.get('jb-nuc-video')){
  customElements.define('jb-nuc-video',class extends HTMLElement{
    connectedCallback(){
      if(this.ready)return;
      this.ready=true;
      this.onClick=(event)=>{if(!event.target.closest('a'))return;event.preventDefault();const frame=document.createElement('iframe');frame.src='https://www.youtube-nocookie.com/embed/wHoe2ykXm80?autoplay=1';frame.title=this.dataset.title;frame.allow='autoplay; encrypted-media; picture-in-picture';frame.allowFullscreen=true;frame.referrerPolicy='strict-origin-when-cross-origin';frame.setAttribute('tabindex','0');this.replaceChildren(frame);frame.focus();};
      this.addEventListener('click',this.onClick);
    }
    disconnectedCallback(){this.removeEventListener('click',this.onClick);this.ready=false;}
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-queens-draft"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('jb-queen-chooser')) {
  customElements.define('jb-queen-chooser', class extends HTMLElement {
    connectedCallback() {
      if (this.dataset.ready) return;
      this.dataset.ready = 'true';
      const tabs = [...this.querySelectorAll('[data-queen-tab]')];
      const panels = [...this.querySelectorAll('[data-queen-panel]')];
      const select = (key, focus) => {
        tabs.forEach(tab => {
          const active = tab.dataset.queenTab === key;
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
          if (active && focus) tab.focus();
        });
        panels.forEach(panel => { panel.hidden = panel.dataset.queenPanel !== key; });
      };
      this.querySelector('[role="tablist"]').hidden = false;
      this.classList.add('is-enhanced');
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab.dataset.queenTab, false));
        tab.addEventListener('keydown', event => {
          let target;
          if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
          if (event.key === 'ArrowLeft') target = tabs[(index - 1 + tabs.length) % tabs.length];
          if (event.key === 'Home') target = tabs[0];
          if (event.key === 'End') target = tabs[tabs.length - 1];
          if (target) { event.preventDefault(); select(target.dataset.queenTab, true); }
        });
      });
      select('mated', false);
    }
  });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["jb-slim-reviews"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('jb-slim-reviews')){
  customElements.define('jb-slim-reviews',class extends HTMLElement{
    connectedCallback(){
      if(this.observer)return;
      this.reviews=[];this.current=0;this.started=false;this.excerpts={};
      try{this.excerpts=JSON.parse(this.dataset.jbExcerpts||'{}');}catch(error){this.excerpts={};}
      this.source=this.querySelector('.jb-slim-reviews__source');
      this.bar=this.querySelector('.jb-slim-reviews__bar');
      this.dialog=this.querySelector('dialog');
      this.onClick=(event)=>{
        if(event.target.closest('[data-prev]'))this.move(-1);
        if(event.target.closest('[data-next]'))this.move(1);
        if(event.target.closest('[data-open]'))this.openReview();
        if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}
      };
      this.addEventListener('click',this.onClick);
      this.observer=new MutationObserver(()=>{cancelAnimationFrame(this.frame);this.frame=requestAnimationFrame(()=>this.collect());});
      this.observer.observe(this.source,{childList:true,subtree:true,characterData:true});
      this.collect();
    }
    disconnectedCallback(){this.observer?.disconnect();this.observer=null;cancelAnimationFrame(this.frame);this.removeEventListener('click',this.onClick);}
    collect(){
      const seen=new Set();const reviews=[];
      // Support both legacy Judge.me cards and the current Cards Carousel markup.
      this.source.querySelectorAll('.jdgm-card[data-review-id], .jm-review-item').forEach((card,index)=>{
        if(card.hasAttribute('data-clone-type')||card.closest('[data-clone-type]'))return;
        const id=card.getAttribute('data-review-id')||card.querySelector('[data-review-id]')?.getAttribute('data-review-id')||card.id||'widget-card-'+index;
        if(seen.has(id))return;seen.add(id);
        const body=card.querySelector('.jdgm-text, .jm-review-text, .jm-review-body, .jm-review-content, .jm-review-item__body, .jdgm-rev__body, [data-review-body], blockquote');
        const text=body?.textContent.trim();
        const name=card.querySelector('.jdgm-reviewer-name, .jm-reviewer-name, .jm-review-author, .jm-review-item__author, .jdgm-rev__author')?.textContent.trim()||'';
        const ratingEl=card.querySelector('[data-rating], [aria-label*="out of 5"], [aria-label*="stars"]');
        const ratingText=ratingEl?.getAttribute('data-rating')||ratingEl?.getAttribute('aria-label')||'';
        const match=ratingText.match(/[1-5]/);
        const onStars=card.querySelectorAll('.jdgm-stars .jdgm--on, .jm-star--filled, .jm-star--full').length;
        const rating=onStars|| (match ? Number(match[1]) : 0);
        if(text&&rating>0&&rating<=5)reviews.push({id,text,name,rating});
      });
      // Page- or product-specific review IDs are assigned in Shopify custom fields.
      // Only reviews actually supplied by the Judge.me Cards Carousel may appear.
      const selected=(this.getAttribute('data-jb-review-ids')||'').split(/[\s,;]+/).map(x=>x.trim()).filter(Boolean);
      const allowed=new Set(selected);
      const selectedReviews=allowed.size?reviews.filter(review=>allowed.has(review.id)):reviews;
      const signature=JSON.stringify(selectedReviews);if(signature===this.signature)return;this.signature=signature;
      this.reviews=selectedReviews;this.current=Math.min(this.current,Math.max(0,selectedReviews.length-1));
      if(!this.started){const start=selectedReviews.findIndex(review=>review.id===this.dataset.jbStart);if(start>=0){this.current=start;this.started=true;}}
      this.bar.hidden=!selectedReviews.length;const empty=this.querySelector('[data-empty]');if(empty)empty.hidden=!!selectedReviews.length;
      if(selectedReviews.length)this.show();
    }
    stars(el,review){el.textContent='★'.repeat(review.rating)+'☆'.repeat(5-review.rating);el.setAttribute('role','img');el.setAttribute('aria-label',review.rating+'/5');}
    excerpt(review){
      if(!this.classList.contains('jb-slim-reviews--excerpts'))return review.text;
      const text=review.text.replace(/\s+/g,' ').trim();
      const chosen=this.excerpts[review.id];
      if(typeof chosen==='string'&&text.includes(chosen))return chosen;
      const sentence=text.match(/^.{1,125}?[.!?](?:\s|$)/);
      if(sentence)return sentence[0].trim();
      if(text.length<=125)return text;
      const cut=text.lastIndexOf(' ',120);return text.slice(0,cut>0?cut:120)+'…';
    }
    show(){const review=this.reviews[this.current];this.stars(this.querySelector('[data-stars]'),review);this.querySelector('[data-quote]').textContent='“'+this.excerpt(review)+'”';this.querySelector('[data-name]').textContent=review.name;this.querySelector('[data-prev]').disabled=this.reviews.length<2;this.querySelector('[data-next]').disabled=this.reviews.length<2;}
    move(step){if(!this.reviews.length)return;this.current=(this.current+step+this.reviews.length)%this.reviews.length;this.show();}
    openReview(){const review=this.reviews[this.current];if(!review)return;this.stars(this.querySelector('[data-full-stars]'),review);this.querySelector('[data-full-quote]').textContent=review.text;this.querySelector('[data-full-name]').textContent=review.name;this.dialog.showModal();}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
            Currency.convertAll(shopCurrency, $('#currencies span.selected').attr('data-currency'));
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();
})();
